// Central API base URL for the HRMS backend.
// Override per environment via REACT_APP_API_BASE_URL in .env; otherwise falls
// back to the production backend. Changing the backend is now a one-line edit.
export const BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "https://hrmsapi.fintrekmarketing.com"
